// extracted by mini-css-extract-plugin
module.exports = {"control":"Practice_control__2Zwhv","select":"Practice_select__2pAIx"};